import React, {Component} from 'react'
import ReactTable from "react-table";
import { Redirect } from 'react-router-dom'
import * as config from '../../Configuration/Config.js'
import UserProfile from '../../Configuration/UserProfile.js'

class FoldersProfile extends Component {
    constructor() {
        super();
        
        this.handleChange = this.handleChange.bind(this)        
        this.handleChangeVisualizations = this.handleChangeVisualizations.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCancel = this.handleCancel.bind(this)        
        this.fetchVisualizationsList = this.fetchVisualizationsList.bind(this)

        this.state = {
            is_loaded: false,
            has_error: false,
            error_message: '',
            redirect_back: false,
            customer_id: 0,
            folder_id: null, 
            folder: null,           
            visualizations: []   
        }
        
    }

    handleChange(event) {
        let data = this.state.folder;
        data[event.target.name] = event.target.value;
        this.setState({folder: data});                
    }
    handleChangeVisualizations(e) {
        console.log('handleChangeVisualizations: ' + e.target.name)
        let folder = this.state.folder;
                    
        if (e.target.checked) {
            folder.visualizations.push(e.target.name);
        } else {
            folder.visualizations = folder.visualizations.filter(x => x !== e.target.name);
        }

        this.setState({folder: folder});       

    }
    handleSave(event) {
        event.preventDefault();
        
        const folder = this.state.folder;
        const customer_id = this.props.match.params.cid;
        const folder_id = this.props.match.params.id;

        console.log(folder);
        
        if (!folder.folder_name){            
            this.setError('Folder Name is required');
            return;
        }

        if (!folder.sort_order){            
            this.setError('Sort Order is required');
            return;
        }       
        
        // Add user with default permission if new
        this.profile = new UserProfile();                
        var varUserId = this.profile.UserId();
        console.log('varUserId: ' + varUserId);

        var that = this;
                
        let vizuri = config.getAcumenAPIURL('customer/' + customer_id + '/folder/' + folder_id);        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix()); 
        myHeaders.append("user_id", varUserId); 
        console.log('myHeaders: ' + myHeaders);
            fetch(vizuri, {
                method: 'post',
                headers: myHeaders,
                body: JSON.stringify(folder)
            }).then(function(response) {
                //console.log(response.status);
                //console.log(response.json());            
                if (response.status >= 400) {
                    console.log(response);
                    throw new Error("Bad response from server");
                }
                console.log('SAVED Viz');
                that.setRedirect();   
            });                
           

    }

    handleDelete(event) {
        event.preventDefault();
        
        const canDel = window.confirm('Are you sure you want to delete this folder?');
        
        if (canDel === false) {
            return;
        }
        
        const customer_id = this.props.match.params.cid;
        const folder_id = this.props.match.params.id;
        var that = this;
        
        let vizuri = config.getAcumenAPIURL('customer/' + customer_id + '/folder/' + folder_id + '/delete');        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix()); 

        fetch(vizuri, {
            method: 'get',
            headers: myHeaders
        }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            that.setRedirect();        
        });
    }

    handleCancel(event) {
        event.preventDefault();
        this.setRedirect();   
    }

    setRedirect() {
        this.setState({redirect_back: true});
    }

    setError(message){
        this.setState({has_error: true, error_message: message});
    }

    componentDidMount() {  
        const customer_id = this.props.match.params.cid;
        const folder_id = this.props.match.params.id;

        if (folder_id === 'new') {
            const data = {
                folder_id: folder_id,
                customer_id: customer_id,
                folder_name: '',
                sort_order: 0,
                visualizations: []
            };
            this.fetchVisualizationsList(customer_id, folder_id, data);
            return;
        }
        else
        {
            var that = this;
                       
            let vizuri = config.getAcumenAPIURL('customer/' + customer_id + '/folder/' + folder_id);        
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
            myHeaders.append("table-prefix", config.getTablePrefix()); 
            
            fetch(vizuri, {
                method: 'get',
                headers: myHeaders
               }).then(function(response) {
                    if (response.status >= 400) {
                    throw new Error("Bad response from server");
                    }
                    return response.json();
              })
              .then(function(data) {
               console.log('folders loaded')
               const folderdata =
               {
                folder_id: data.folders[0].id,
                customer_id: data.folders[0].customer_id,
                folder_name: data.folders[0].folder_name,
                sort_order: data.folders[0].sort_order,
                visualizations: data.folders[0].visualizations
               }
               that.fetchVisualizationsList(customer_id, folder_id, folderdata);
               
               return;
            });
        }
    }

    fetchVisualizationsList(customer_id, folder_id, folder)
    {
        var that = this;
        const uri = config.getUriPath('customers/viewscw/' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
        })
        .then(function(data) { 
            console.log('vizlist')
           
            that.setState({ is_loaded: true, customer_id: customer_id, folder_id: folder_id, visualizations: data, folder:folder });                                                                     
        });
    }

    render() {
        if (this.state.is_loaded === false) {return <div></div>}

        const folder_id = this.state.folder_id
        const folder = this.state.folder
        const customer_id = this.state.customer_id

        if (this.state.redirect_back){
            return <Redirect to={'/cw/'} />
        }

        if (!folder.visualizations){
            folder.visualizations = [];
        }

        console.log(folder)
        console.log(folder["folder_name"])
        console.log(folder.sort_order)

        const title = (folder_id === "new") ? "Create New Folder" : "Edit Folder: " //+ division.business_division_name
        return  <div>
                    <div className="center-div">
                        <h1>{title}</h1>
                    </div>
                    <br />
                    <div className="form-wrapper-bd">
                        <form>
                            <div className="container-fluid">
                                <div className="form-group">
                                    <label htmlFor="folder_name">Folder Name:</label>
                                    <input type="text" onChange={this.handleChange} className="form-control" name="folder_name" defaultValue={folder.folder_name}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="sort_order">Sort Order:</label>
                                    <input type="text" onChange={this.handleChange} className="form-control" name="sort_order" defaultValue={folder.sort_order}/>
                                </div>
                            </div>

                            <div className="dashboard-roles role-checkboxes">
                                <h3>Visualizations</h3>
                                <div className="form-group">
                                        {this.state.visualizations.map((item) => {
                                            return (
                                                <div className="form-check" key={item.rid}>
                                                    <input className="form-check-input" type="checkbox" value="" name={item.rid} id={item.rid} onChange={this.handleChangeVisualizations} defaultChecked={folder.visualizations.indexOf(item.rid) !== -1} />
                                                    <label className="form-check-label" htmlFor={item.rid}>{item.title}</label>
                                                </div>
                                            )
                                        })}
                                </div>
                            </div>
        
                            <div className={this.state.has_error ? "form-group" : "hidden"}>
                                <div className="errorMsg">{this.state.error_message}</div>
                            </div>
                            <div className="form-group">
                                <div className="centerAlign" colSpan="2">
                                    <button onClick={this.handleSave} name="save" className="loginButtonBD btn btn-primary">Save</button>
                                    &nbsp;&nbsp;
                                    <button onClick={this.handleDelete} name="delete" className={folder_id === "new" ? "hidden" : "loginButtonBD btn btn-danger"}>Delete</button>
                                    &nbsp;&nbsp;
                                    <button onClick={this.handleCancel} name="cancel" className="loginButtonBD btn btn-info">Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
    }
}

export default FoldersProfile


// WEBPACK FOOTER //
// ./src/Components/CW/folders/FoldersProfile.js